module.exports = __webpack_public_path__ + "static/media/HCMM052.72788fe2.jpg";